<script>
import DropDown from '../reUse/DropDown.vue';
import DnevnikBeri from './DnevnikJadralnihPilotov_beri.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/DnevnikPilotovJadranja-sl.json';
import en from '@/Prevodi/DnevnikPilotovJadranja-en.json';
import it from '@/Prevodi/DnevnikPilotovJadranja-it.json';
import {config} from "@/config";
export default {
  components: {
    DropDown,
    DnevnikBeri,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      prikaz: 'vnosi',
      //uporabljeni
      datum: '',
      odhod_cas: '',
      model: '',
      regLetala: '',
      imeVodje: '',
      nacinStarta: '',
      krajVzleta: '',
      naloga: '',
      st_letov: '',
      kilometrov: '',
      opombe: '',
      operativa: 'dnevno',
      casLetenja: null,
      text: '',
      types: '',
      ShowNoti: false,
      //neuporabljeni
      vloga: 'PIC',
      ttof: '',
      posadka: 'SE',
      fstd: '',
      prihod_cas: '',
      dVzlet: false,
      dPristanek: false,
      dLetalo: false,
      Letala: [],
      LetalaMotorna: [],
      Letalisca: [],
      krajPristanka: '',
      pogoji: 'dan',
      pristanki: '',
      user: config.FullUser.id,


    };
  },
  computed: {},
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {

  },
  methods: {
    VnosPLogBook() {
      let app = this;
      if (this.datum !== '' && this.imeVodje !== '' && this.odhod_cas !== '' && this.krajVzleta !== '' && this.casLetenja !== '' && this.model !== '' && this.regLetala !== '') {
        var php_podatki = new URLSearchParams();
        php_podatki.append('datum', this.datum);
        php_podatki.append('odhod_cas', this.odhod_cas);
        php_podatki.append('zrakoplov_model', this.model);
        php_podatki.append('zrakoplov_registracija', this.regLetala);
        php_podatki.append('ime_vodje_zrakoplova', this.imeVodje);
        php_podatki.append('nacin_starta', this.nacinStarta);
        php_podatki.append('odhod_kraj', this.krajVzleta);
        php_podatki.append('naloga', this.naloga);
        php_podatki.append('st_letov', this.st_letov);
        php_podatki.append('preleteni_km', this.kilometrov);
        php_podatki.append('vrsta_leta', this.operativa);
        php_podatki.append('trajanje', this.casLetenja);
        php_podatki.append('opombe', this.opombe);
        axios
            .post('./api/pl_dodaj/jadralno/', php_podatki, {withCredentials: true})
            .then((response) => {
              this.text = this.$t('obvestilaLJ.zapisDodan');
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.datum = '';
              this.odhod_cas = '';
              this.model = '';
              this.regLetala = '';
              this.imeVodje = '';
              this.nacinStarta = '';
              this.krajVzleta = '';
              this.naloga = '';
              this.st_letov = '';
              this.kilometrov = '';
              this.operativa = 'dnevno';
              this.casLetenja = null;
              this.opombe = '';
              var requiredPolja = ['datum', 'imeVodje', 'prihod_cas', 'odhod_cas', 'krajPristanka', 'krajVzleta', 'pristanki', 'varianta', 'regLetala', 'ttof'];
              this.ResetRequired(requiredPolja);
            })
            .catch(napaka => {
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.sporocilo !== undefined) {
                this.text = this.$t('obvestilaLJ.napakaVnosa');
              } else {
                this.text = this.$t('obvestilaLJ.napakaVnosa');
              }
              this.types = "Napaka";
              this.ShowNoti = true;
            });
      } else {
        var requiredPolja = ['datum', 'imeVodje', 'prihod_cas', 'odhod_cas', 'krajPristanka', 'krajVzleta', 'pristanki', 'varianta', 'regLetala', 'ttof'];
        this.CheckInputs(requiredPolja);
        this.text = this.$t('obvestilaLJ.napakaInputa');
        this.types = "Napaka";
        this.ShowNoti = true;
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]); //samo za dev
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('mainLJ.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('mainLJ.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnosi'}" @click="prikaz = 'vnosi'" data-umami-event="DnevnikPilotov-Jadralni-vnosi">
              <i class="fas fa-edit"></i>
              <span>{{$t('navsLJ.vnos')}}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'branje'}" @click="prikaz = 'branje'" data-umami-event="DnevnikPilotov-Jadralni-branje">
              <i class="fas fa-list"></i>
              <span>{{$t('navsLJ.dnevnik')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
  <dnevnik-beri v-if="prikaz === 'branje'" :user="user" />
  <div v-else class="container p-2">
    <!-- DATUM -->
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum">{{$t('labelsLJ.datum')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required />
      </div>
    </div>
    <!-- ČAS VZLETA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: odhod_cas.length > 0 }" class="label-time p-2" for="odhod_cas">{{$t('labelsLJ.casO')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="odhod_cas" v-model="odhod_cas" required />
      </div>
    </div>
    <!-- KRAJ VZLETA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: krajVzleta.length > 0 }" class="label" for="krajVzleta">{{$t('labelsLJ.krajV')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" v-model="krajVzleta" required />
      </div>
    </div>
    <!-- NALOGA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: naloga.length > 0 }" class="label" for="naloga">{{$t('labelsLJ.naloga')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naloga" v-model="naloga" required />
      </div>
    </div>
    <!-- ČAS PRIHODA -->
    <!--         <div class="col-12">
                <div class="container">
                    <label :class="{ hidden: prihod_cas.length > 0 }" class="label-time p-2" for="prihod_cas">{{$t('labelsLJ.casP')}}</label>
                    <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="prihod_cas" v-model="prihod_cas" required />
                </div>
            </div> -->
    <!-- KRAJ PRISTANKA-->
    <!--         <div class="col-12">
                <div class="container">
                    <label :class="{ hidden: krajPristanka.length > 0 }" class="label" for="krajPristanka">{{$t('labelsLJ.krajP')}}</label>
                    <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" v-model="krajPristanka" required />
                </div>
            </div> -->
    <!-- MODEL, VARIANTA ZRAKOPLOVA-->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: model.length > 0 }" class="label" for="model">{{$t('labelsLJ.model')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="model" v-model="model" required />
      </div>
    </div>
    <!-- REGISTRACIJA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: regLetala.length > 0 }" class="label" for="regLetala">{{$t('labelsLJ.reg')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" v-model="regLetala" required />
      </div>
    </div>
    <!-- NAČIN STARTA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: nacinStarta.length > 0 }" class="label" for="nacinStarta">{{$t('labelsLJ.nacinStarta')}}</label>
        <select class="input border-0 rounded-4 p-2 fs-5" id="nacinStarta" v-model="nacinStarta">
          <option value="A">{{$t('optionsLJ.aerozaprega')}}</option>
          <option value="V">{{$t('optionsLJ.vitla')}}</option>
        </select>
      </div>
    </div>
    <!-- IME VODJE ZRAKOPLOVA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: imeVodje.length > 0 }" class="label" for="imeVodje">{{$t('labelsLJ.ime')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="imeVodje" v-model="imeVodje" required />
      </div>
    </div>
    <!-- TTOF -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: ttof.length > 0 }" class="label-time p-2" for="ttof">{{$t('labelsLJ.skupniCas')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="TTOF" id="ttof" v-model="casLetenja" required />
      </div>
    </div>
    <!-- ŠT LETOV -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: st_letov > 0 }" class="label" for="st_letov">{{$t('labelsLJ.stLetov')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="st_letov" v-model="st_letov" required />
      </div>
    </div>
    <!-- PRLEETELNI KILOMTERI -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: kilometrov > 0 }" class="label" for="pristanki">{{$t('labelsLJ.kilometri')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="pristanki" v-model="kilometrov" required />
      </div>
    </div>
    <!-- OPERATIVNI POGOJI -->
    <div class="col-12">
      <div class="container">
        <label class="label-time p-2" for="operativa">{{$t('labelsLJ.op')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <div class="row">
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="dan" value="dnevno" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> {{$t('labelsLJ.opD')}}</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="slepo" value="slepo" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> {{$t('labelsLJ.opN')}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- OPOMBE -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opombe.length > 0 }" class="label" for="opombe">{{$t('labelsLJ.opomba')}}</label>
        <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opombe" v-model="opombe" rows="6" autocomplete="off">
                </textarea>
      </div>
    </div>
    <!-- GUMB ZA DODAJANJE-->
    <div class="container p-2">
      <button @click.prevent="VnosPLogBook()" class="btn btn-primary rounded-pill btn-add col-12">{{$t('buttonsLJ.vnesiZapis')}}</button>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>